import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesMenuOpen, setIsServicesMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const toggleServicesMenu = () => {
    setIsServicesMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={`header_section ${isSticky ? "sticky-header" : ""}`}>
      <div className="container-fluid">
        <nav className="navbar custom_nav-container">
          <Link className="navbar-brand" to="/">
            <img
              src="images/vitri-blue-logo-crop.png"
              alt="VITRI ENTERPRISES Logo"
              className="brand-logo"
              width={240}
              height={72}
              loading="eager"
              decoding="async"
              fetchpriority="high"
            />
          </Link>
          <ul className={`nav-links ${isMenuOpen ? "open" : ""}`}>
            <li>
              <Link
                to="/"
                className={location.pathname === "/" ? "active-tab" : ""}
              >
                HOME
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={location.pathname === "/about" ? "active-tab" : ""}
              >
                ABOUT US
              </Link>
            </li>
            <li className={`has-submenu ${isServicesMenuOpen ? "open" : ""}`}>
              <span
                className={`service-text menu-link ${
                  [
                    "/cctv-camera",
                    "/video-door-phone",
                    "/epabx",
                    "/boom-barrier-system",
                    "/networking-solutions",
                    "/access-control",
                  ].includes(location.pathname)
                    ? "active-tab"
                    : ""
                }`}
                onClick={toggleServicesMenu}
              >
                OUR SERVICES
              </span>
              <ul className="submenu">
                <li>
                  <Link to="/cctv-camera">CCTV Camera</Link>
                </li>
                <li>
                  <Link to="/video-door-phone">Video Door Phone</Link>
                </li>
                <li>
                  <Link to="/epabx">EPABX</Link>
                </li>
                <li>
                  <Link to="/boom-barrier-system">Boom Barrier System</Link>
                </li>
                <li>
                  <Link to="/networking-solutions">Networking Solutions</Link>
                </li>
                <li>
                  <Link to="/access-control">Access Control</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link
                to="/our-work"
                className={
                  location.pathname === "/our-work" ? "active-tab" : ""
                }
              >
                OUR WORK
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={location.pathname === "/contact" ? "active-tab" : ""}
              >
                CONTACT US
              </Link>
            </li>
          </ul>
          <button
            className="menu-toggle-btn"
            onClick={toggleMenu}
            aria-expanded={isMenuOpen}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            <span className="menu-bar"></span>
            <span className="menu-bar"></span>
            <span className="menu-bar"></span>
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
